import React from 'react';
import { Paper,Divider, Grid } from '@material-ui/core';
import { FilterComponent } from '../../../shared_elements';
import Skeleton from '@material-ui/lab/Skeleton';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'
import { leasesStatusGraphFilterOps } from '../'
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/no-data-to-display')(Highcharts);
const LeaseStatusGraph = ({ leaseStatGraph, skeletonLoader, filter, getResponseBack, callExternalFunction }) => {
    let filterOptions = Object.assign({}, leasesStatusGraphFilterOps);
    var colors = leaseStatGraph && leaseStatGraph.color
    const options = {
        chart: {
            type: 'pie',
            options3d: {
                enabled: true,
                alpha: 30
            },
            styledMode: true
        },
        title: {
            text: 'Based on Status',
            align: 'left',
            style: {
                fontFamily: 'Conv_IBMPlexSans-Regular',
                fontSize:'16px'
            }
        },
        subtitle: {
            text: `${leaseStatGraph.title ? leaseStatGraph.title : ''}`,
            align: 'left'
        },
        colors:colors,
        plotOptions: {
            pie: {
                innerSize: 100,
                depth: 60,
                dataLabels: {
                    enabled: true,
                    softConnector: false
                },
                point: {
                    events: {
                      click: function(oEvent) {
                        callExternalFunction(oEvent.point.name, '', 'basedOnStatus');
                      }
                    }
                  },
                showInLegend: false,
                allowPointSelect: true,
                cursor: 'pointer',
                animation:false
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
            pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> <br/>'
        },
        series: [{
            name:'Count',
            data: leaseStatGraph && leaseStatGraph.lease_type && leaseStatGraph.lease_type,
            colorByPoint: true,
            dataLabels: {
                formatter: function () {
                    return this.point.name + ':</b> ' +
                        '('+this.y+')';
                }
            }
        }],
        credits: false,
        exporting: {
            buttons: {
                contextButton: {
                  menuItems: ['downloadPNG', 'downloadPDF'],
                },
            }
         }
    }

    return (
        skeletonLoader ? <Skeleton variant="rect" height={700} width='100%' /> : 
        <Paper>
            <div style={{padding:'0 5px'}}>
                <FilterComponent 
                    filter={filter}
                    filterMenu={filterOptions}
                    getResponseBack={(applyFilter) => getResponseBack(applyFilter)}
                />
            </div>
            <Divider />
            <div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                />
            </div>
        </Paper>
    )
}
export default LeaseStatusGraph
